import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  fieldset: {
    border: 0,
    padding: 0,
    margin: 0,
    minWidth: 0
  },
  recalculatingContent: {
    opacity: 0.5,
    pointerEvents: 'none'
  }
}));
